// extracted by mini-css-extract-plugin
export default {"DocumentItem__Container":"DocumentItem_DocumentItem__Container__AbBDK","DocumentItem__Container__Selected":"DocumentItem_DocumentItem__Container__Selected__jMXFq"};